const listAreas = [
	{tillName: "L2", displayName: "Large List"},
	{tillName: "L", displayName: "Standard List"},
	{tillName: "F", displayName: "Function List"},
	{tillName: "F3", displayName: "Bottom Bar"},
];

export default listAreas;
